import dynamic from 'next/dynamic';

import { HotelGalleryTileProps } from './HotelGalleryTitle.types';

export const HotelGalleryTitleMGP = dynamic<HotelGalleryTileProps>(() =>
  import('./HotelGalleryTitle').then(module => module.HotelGalleryTitle)
);
